import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { Outlet } from "react-router-dom";
import axios from "axios";

function ProfileLayout() {
    const { user } = useAuth();
    const [logo, setLogo] = useState("");

    function Navbar() {
        return (
            <nav
                className="navbar navbar-expand-lg bg-body-tertiary py-0"
                style={{ backgroundColor: "white", borderBottom: "1px solid #e9ecef" }}
            >
                <div
                    className="container-fluid d-flex align-items-center justify-content-between"
                    style={{ backgroundColor: "white", minHeight: 72 }}
                >
                    <a className="navbar-brand d-flex align-items-center py-0" href="/">
                        <img
                            src={logo?.photo}
                            alt="logo"
                            style={{ maxWidth: "220px", maxHeight: "46px" }} // 2. görsel gibi
                            className="img-fluid"
                        />
                    </a>

                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-0"></ul>

                        <div className="d-flex align-items-center">
                            <a
                                href="/profile"
                                className="d-flex align-items-center text-decoration-none"
                                style={{ gap: 10, color: "inherit" }}
                            >
                                <i
                                    className="fa fa-user-circle"
                                    style={{ fontSize: 44, lineHeight: 1 }}
                                    aria-hidden="true"
                                />
                                <span style={{ lineHeight: 1.15 }}>
                                    <strong>{user?.name}</strong>
                                    <br />
                                    {user?.role}
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </nav>
        );
    }

    const getlogo = async () => {
        try {
            const headerss = {
                accept: "*/*",
                "Access-Control-Allow-Credentials": "false",
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/json",
            };

            const res = await axios({
                method: "get",
                url: "https://express.heryerdeingilizce.com/getlogo",
                headers: headerss,
            });

            setLogo(res.data[0]);
        } catch (err) { }
    };

    useEffect(() => {
        console.log(user.user.expiryDate);
        getlogo();
    }, []);

    if (!user) {
        window.location.href = "/auth/login";
        return null;
    }

    return (
        <div>
            <Navbar />
            <div className="wrapper">
                <div id="content">
                    <Outlet />
                </div>
            </div>
        </div>
    );
}

export default ProfileLayout;